import sortBy from 'lodash.sortby';
import { minimumSummitIClassInvestAmount } from '../../flows/shared/summit.utils';
import { I_CLASS_MINIMUM } from '../../flows/shared/utils';

export const sortRetirementMutualFunds = (
  mutualFunds,
  rewardsAvailable,
  amount
) => {
  const iClassAmount = rewardsAvailable?.iClassFunds
    ? minimumSummitIClassInvestAmount
    : I_CLASS_MINIMUM;
  const includeIClass = amount === iClassAmount;

  return sortBy(
    mutualFunds.filter(
      fund =>
        // retirement funds only
        fund.name.includes('Retirement') &&
        // not iClass funds
        fund.iClass === includeIClass &&
        // not income funds or balanced funds -- TODO
        fund.trpCode !== 'RIB' &&
        fund.trpCode !== 'RPE'
    ),
    ['name']
  );
};
